import { Callout } from './components/callout.tsx'
import { PaidFeature } from './components/paid-feature.tsx'

export const meta = () => [
	{ title: 'GitHub Integration · xcelera docs' },
	{
		name: 'description',
		content:
			'Install the GitHub App to get Lighthouse performance results as check runs on pull requests.',
	},
]

# GitHub Integration <PaidFeature />

xcelera integrates with GitHub to automatically report performance results as check runs on your pull requests.

## Installing the GitHub App

1. Go to **Settings → GitHub** in your xcelera dashboard
2. Click **Install GitHub App**
3. Select the GitHub organization and repositories you want to connect
4. Authorize the installation

Once installed, the connection appears in your settings page.

## How check runs work

When you trigger an audit with Git context (via the [API or CLI](/docs/api-usage)), xcelera creates a GitHub check run on the associated commit:

1. A **pending** check run appears on your PR
2. As the audit runs, the check is updated to **in progress**
3. When complete, the check shows the performance score and a summary of key metrics
4. The check links back to the full audit report on xcelera

The check run includes:

- Overall performance score
- Key metrics: LCP, TBT, CLS
- Comparison with previous audit results (when available)
- A direct link to the detailed report

<Callout type="info">
	Check runs require Git context (owner, repo, branch, commit hash) in the audit
	request. The [API & CLI](/docs/api-usage) guide shows how to pass this
	context.
</Callout>

## Connecting repositories

The GitHub App needs access to each repository where you want check runs. You can manage repository access from your GitHub organization settings or from the xcelera GitHub settings page.

## Disconnecting

To remove the integration, go to **Settings → GitHub** and click **Disconnect**. This removes the app installation — existing check runs on past PRs will remain but no new ones will be created.

<Callout type="tip">
	Combine GitHub check runs with the [API](/docs/api-usage) in a GitHub Actions
	workflow for fully automated performance checks on every PR.
</Callout>
